import StickySummary from './sticky_summary';

export default StickySummary;
